module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-03.7c72a1e7.png";